import { z } from 'zod';
import { ASSIGNEE_MODE_NAMES } from '../../events/assignee-mode-names.js';
import { CAL_EVENT_MAX_TAGS } from '../../events/cal-event-max-tags.js';
import { PROMO_MODE_NAMES } from '../../events/promo-mode-names.js';
import { newTagsSchema } from '../cal-tag/new-tags-schema.js';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
export const calEventTemplateSettingsShape = {
    promoMode: z.enum(PROMO_MODE_NAMES).optional().default('optional'),
    presetPromotionId: optionalUuidString('Invalid promotion.').optional().nullable(),
    promoLocked: z.boolean().optional().default(false),
    assigneeMode: z.enum(ASSIGNEE_MODE_NAMES).optional().default('optional'),
    allDay: z.boolean().optional().default(false),
    newTags: newTagsSchema,
    tagIds: z
        .array(requiredUuidString('Tag is required.', 'Invalid tag ID.'))
        .max(CAL_EVENT_MAX_TAGS, `A template can have at most ${CAL_EVENT_MAX_TAGS} tags.`)
        .refine((ids) => new Set(ids).size === ids.length, 'Each tag can only be added once.')
        .optional()
        .default([]),
};
//# sourceMappingURL=cal-event-template-settings-shape.js.map